module.exports = __webpack_public_path__ + "img/panel2.8d600fb1.svg";